import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ForgotPasswordApi } from 'src/api/ForgotPasswordApi';
import { setError, setLoading, setSuccess } from 'src/common/commonAction';
import { actionTypes } from 'src/forgotPassword/forgotPasswordAction';

function* requestForgotPassword(action) {
  const { values } = action;
  try {
    yield put(setLoading());
    const { data }: AxiosResponse = yield call(ForgotPasswordApi.postForgotPassword, values);
    if (data) {
      const { message } = data;

      yield put({
        type: actionTypes.FORGOT_PASSWORD_SUCCESS,
        message
      });
      yield put(setSuccess());
    } else {
      yield put({ type: actionTypes.FORGOT_PASSWORD_FAILURE });
      yield put(setError());
    }
  } catch (error) {
    yield put({ type: actionTypes.FORGOT_PASSWORD_FAILURE });
    yield put(setError());
  }
}

export function* forgotPasswordSaga() {
  yield takeLatest(actionTypes.FORGOT_PASSWORD_REQUEST, requestForgotPassword);
}
